import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const { data, actions } = usePageBanner();

	if (!data.banner) return null;

	return (
		<div className="col-span-full">
			<PageMessage
				id="starter-dashboard-banner"
				role="alert"
				dismissable={data.banner.dismissable}
				primaryAction={data.banner.primaryAction}
				secondaryAction={data.banner.secondaryAction}
				severity={data.banner.severity}
				message={data.banner.message}
				onClose={actions.onDismiss}
				sx={{ position: 'sticky', top: 0, zIndex: 1 }}
			/>
		</div>
	);
}
